import { ProductType } from '../types';

export interface OrganicOption {
  v: string;
  ico: string;
  t: string;
  s: string;
  apiValue?: string;
}

export const PRODUCT_OPTS: OrganicOption[] = [
  { v: 'fotovoltaico', ico: 'sun', t: 'Fotovoltaico', s: 'Pannelli solari per la tua casa', apiValue: 'Photovoltaic' },
  { v: 'pompa', ico: 'heat', t: 'Pompa di calore', s: 'Riscaldamento efficiente', apiValue: 'Heatpump' },
  { v: 'sostituzione', ico: 'swap', t: 'Sostituzione impianto fotovoltaico', s: 'Rinnova un impianto esistente', apiValue: 'PV_Retrofit' },
  { v: 'fv_pompa', ico: 'duo', t: 'Fotovoltaico e Pompa di calore', s: 'La soluzione completa', apiValue: 'Photovoltaic + Heatpump' },
];

export const HOME_OPTS: OrganicOption[] = [
  { v: 'singola', ico: 'house', t: 'Casa singola / indipendente', s: 'Villa o casa unifamiliare', apiValue: 'detached_house' },
  { v: 'condominio', ico: 'build', t: 'Condominio', s: 'Appartamento in condominio', apiValue: 'townhouse' },
  { v: 'palazzina', ico: 'houses', t: 'Palazzina (fino a 6 famiglie)', s: 'Piccolo edificio plurifamiliare', apiValue: 'small_building' },
  { v: 'industriale', ico: 'ware', t: 'Edificio industriale / capannone', s: 'Uso commerciale o produttivo', apiValue: 'commercial_building' },
  { v: 'altro', ico: 'perg', t: 'Pergolati & altro', s: 'Tettoie, pensiline, altro', apiValue: 'other' },
];

export const TIMELINE_OPTS: OrganicOption[] = [
  { v: '1-2', ico: 'alarm', t: 'Tra 1 e 2 mesi', s: 'Il prima possibile', apiValue: 'one_to_two_months' },
  { v: '3-4', ico: 'cal', t: 'Tra 3 e 4 mesi', s: 'Nei prossimi mesi', apiValue: 'three_to_four_months' },
  { v: '5+', ico: 'cal', t: 'Fra più di 5 mesi', s: 'Sto valutando con calma', apiValue: 'more_than_5_months' },
  { v: 'nonso', ico: 'help', t: 'Non so ancora', s: 'Voglio prima informarmi', apiValue: 'dont_know' },
];

export const SPEND_OPTS: OrganicOption[] = [
  { v: '<100', ico: 'bolt', t: 'Fino a 100 € / mese', s: 'Consumi contenuti' },
  { v: '100-200', ico: 'bolt', t: '100 – 200 € / mese', s: 'Consumi medi' },
  { v: '>200', ico: 'bolt', t: 'Oltre 200 € / mese', s: 'Consumi elevati' },
];

export const SPEND_CALLOUT: Record<string, { amount: string; text: string }> = {
  '<100': { amount: '70€', text: 'di risparmio stimato al mese con il fotovoltaico.' },
  '100-200': { amount: '120€', text: 'di risparmio stimato al mese con il fotovoltaico.' },
  '>200': { amount: '250€', text: 'di risparmio stimato al mese con il fotovoltaico.' },
};

export const SEARCH_TASKS = [
  'Localizzo il tuo Comune…',
  'Controllo gli incentivi statali 2026…',
  'Verifico i bonus regionali e locali…',
  'Calcolo il tuo risparmio stimato…',
];

export const INCENTIVES = [
  { ico: 'euro', t: 'Detrazione fiscale 50%', s: "Recuperi metà della spesa dell'impianto in 10 anni.", tag: 'Attivo' },
  { ico: 'shield', t: 'Bonus regionali', s: 'Contributi a fondo perduto attivi nella tua zona.', tag: 'Disponibile' },
  { ico: 'bolt', t: 'Conto Energetico Enpal', s: "Guadagni sull'energia che immetti in rete con CER e Enpal ONE", tag: 'Attivo' },
];

export const FORM_STEPS = 5;

export const labelFor = (opts: OrganicOption[], v: string) => opts.find((x) => x.v === v)?.t || '';

export function mapProductToApi(v: string): ProductType {
  return (PRODUCT_OPTS.find((o) => o.v === v)?.apiValue as ProductType) || 'Photovoltaic';
}

export function mapToFormData(fields: {
  cap: string;
  product: string;
  home: string;
  timeline: string;
  spend: string;
  name: string;
  email: string;
  phone: string;
}) {
  return {
    zip: fields.cap,
    product_type: mapProductToApi(fields.product),
    house_type: HOME_OPTS.find((o) => o.v === fields.home)?.apiValue || '',
    purchase_time: TIMELINE_OPTS.find((o) => o.v === fields.timeline)?.apiValue || '',
    monthly_spend: fields.spend,
    name: fields.name,
    email: fields.email,
    phone: fields.phone,
  };
}
